export const meta = { id: 'O34', slug: 'historico-conclusao', title: 'Como funciona o histórico de conclusão', description: 'Entenda por que uma conclusão já registrada deve permanecer como fato histórico.', profile: 'owner', category: 'formacoes', type: 'concept', status: 'published', order: 640, keywords: ['histórico','conclusão','data de conclusão','formação'], previous: 'O33', next: 'O34.1', related: ['O32','O33'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como funciona o histórico de conclusão

A conclusão de uma Formação representa um fato histórico do participante naquele momento.

Depois que a Formação foi concluída validamente, alterações administrativas posteriores não devem apagar esse registro histórico.

<HelpImage pendingId="O33.1" alt="Histórico ou data de conclusão de uma Formação" />

<Callout type="important">A versão congelada do Personagrama preserva a conclusão histórica e sua data mesmo diante de alterações posteriores que não devem reescrever o passado do participante.</Callout>
